export { default } from 'pages/authentication/sign-out';
